import { ddeApi } from '@/service/ddeApi'
import { StandarizedGolfPlayer } from '@/views/DataAdmin/types'
import { quarantinePlayerToStandarized } from '@/views/DataAdmin/utils'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'

const fetchQuarantinePlayersApiCallback = async (
  args: FetchApiArgs<object, string, string>
): Promise<FetchApiResponse<StandarizedGolfPlayer>> => {
  const { signal } = args

  const { data } = await ddeApi.endpoints.golf.quarantine.getPlayers({
    signal
  })

  return {
    content: data.players.map(quarantinePlayerToStandarized),
    totalElements: data.totalResultsAvailable
  }
}

export const useQuarantinePlayers = createBaseTableStore({
  storeName: 'Quarantine Players',
  fetchApi: fetchQuarantinePlayersApiCallback
})
